<div id="main">
  <button id="close" mat-dialog-close>
    <fa-icon [icon]="faTimes"></fa-icon>
  </button>
  <div class="modal-header">
    <h4>{{'UNITS_KEY'|translate}}</h4>
  </div>
  <div id="table">
    <app-progressbar *ngIf="isLoading"></app-progressbar>
    <table mat-table [dataSource]="dataSource" matSort class="table-striped" style="width:100%">
      <ng-container matColumnDef="value">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'UNIT'|translate}}</th>
        <td mat-cell *matCellDef="let units">{{units.value | translate }}</td>
        <td></td>
      </ng-container>
      <ng-container matColumnDef="unit">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'KEY'|translate}}</th>
        <td mat-cell *matCellDef="let units">{{units.unit}}
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
    <br clear="left"/>
    <mat-paginator [pageSizeOptions]="pageSizeOptions" showFirstLastButtons [pageSize]="pageSize"></mat-paginator>
  </div>
</div>



